.avatar {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: var(--avatar-size);
  height: var(--avatar-size);
  overflow: hidden;
  background: var(--avatar-bg);
  color: var(--on-avatar);
  border-radius: var(--radius-pill);
}

.initials {
  font-family: var(--font-heading);
  font-size: calc(var(--avatar-size) * 0.34);
  font-weight: var(--weight-extrabold);
  line-height: 1;
}

.photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
}

.photo[data-loaded] {
  opacity: 1;
}
